export enum GameActivity {
  WITH = 1,
  WITHOUT = 2,
  ALL = 3,
}
